import PrintShell, { PrintField, PrintRow, PrintSectionHeader, PrintTextBlock } from '../../../components/print/PrintShell';

export default function DocRequestPrintTemplate({ docRequest: d }) {
  if (!d) return null;
  return (
    <PrintShell printClass="docrequest-print-only" formTitle="DOCUMENT REQUEST FORM">
      <PrintSectionHeader title="Sacrament Information" />
      <PrintRow fields={[
        { label: 'Certificate', value: d.type },
        { label: 'Conferred Date', value: d.conferred_date, flex: 0.6 },
      ]} />
      {d.matrimony ? (
        <PrintRow fields={[
          { label: 'Bride', value: d.bride_name },
          { label: 'Groom', value: d.groom_name },
        ]} />
      ) : (
        <>
          <PrintRow fields={[
            { label: "Recipient's Name", value: d.recipient_name },
            { label: 'Date of Birth', value: d.recipient_birth, flex: 0.6 },
          ]} />
          <PrintRow fields={[
            { label: "Mother's Name", value: d.recipient_mother },
            { label: "Father's Name", value: d.recipient_father },
          ]} />
        </>
      )}
      {d.confirmation ? (
        <PrintField label="Sponsor" value={d.sponsor_name} />
      ) : (
        <PrintRow fields={[
          { label: 'Godfather', value: d.godfather_name },
          { label: 'Godmother', value: d.godmother_name },
        ]} />
      )}
      {!d.matrimony && <PrintField label="Saint Name" value={d.saint_name} />}

      <PrintSectionHeader title="Requestor / Contact" />
      <PrintRow fields={[
        { label: 'Requestor', value: d.requestor_name },
        { label: 'Relationship', value: d.recipient_relationship, flex: 0.6 },
      ]} />
      <PrintRow fields={[
        { label: 'Phone', value: d.phone },
        { label: 'Email', value: d.email },
      ]} />
      <PrintRow fields={[
        { label: 'Method', value: d.method, flex: 0.5 },
        { label: 'Status', value: d.status, flex: 0.5 },
      ]} />

      <PrintSectionHeader title="Address" />
      <PrintField label="Address" value={[d.address_line_1, d.address_line_2].filter(Boolean).join(', ')} />
      <PrintRow fields={[
        { label: 'City', value: d.city },
        { label: 'State', value: d.state, flex: 0.5 },
        { label: 'Zip', value: d.zip, flex: 0.5 },
      ]} />
      {d.comments && <PrintTextBlock label="Comments" value={d.comments} />}
    </PrintShell>
  );
}
